import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { accordionOpenAction, accordionCloseAction } from '../../redux/actions/accordion';
import {
  StyledAccordionBodyContent,
  StyledAccordionWrapper,
  StyledAccordionToggle
} from './styles';
// import './styles';

/**
 * Creates a Generic Accordion Container that can be used to
 * display any passed in content
 */
class Accordion extends Component {
  static propTypes = {
    open: PropTypes.bool,
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    openAction: PropTypes.func.isRequired,
    closeAction: PropTypes.func.isRequired,
    id: PropTypes.string
  };
  static defaultProps = {
    open: false,
    id: ''
  };
  constructor(props) {
    super(props);
    this.state = {
      open: props.open
    };
    this.toggleAccordion = this.toggleAccordion.bind(this);
  }
  /**
   * Toggles the open/closed state of the accordion
   */
  toggleAccordion() {
    const { title, openAction, closeAction } = this.props;
    if (this.state.open) {
      closeAction(title);
    } else {
      openAction(title);
    }
    this.setState({ open: !this.state.open });
  }

  /**
   * Renders the React content into HTML
   * @returns {XML}
   */
  render() {
    const { title, children, id } = this.props;
    const { open } = this.state;
    return (
      <StyledAccordionWrapper id={id} className="row accordion-body">
        <StyledAccordionToggle className="accordion-toggle" onClick={this.toggleAccordion} aria-expanded={open}><h3>{title}</h3></StyledAccordionToggle>
        <StyledAccordionBodyContent className="accordion-body-content" aria-hidden={!open}>
          <span>
            {children}
          </span>
        </StyledAccordionBodyContent>
      </StyledAccordionWrapper>
    )
  }
}

const mapStateToProps = () => ({

});

const mapDispatchToProps = dispatch => ({
  openAction: bindActionCreators(accordionOpenAction, dispatch),
  closeAction: bindActionCreators(accordionCloseAction, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Accordion);



/** WEBPACK FOOTER **
 ** ./src/components/Accordion/index.js
 **/